// A pre-addressed support email opened only by deliberate user interaction.
// Never attach a password, auth token, reset token, Sheet ID or local finance data.
export const BPA_SUPPORT_EMAIL='support@bpasolutions.au';
export function buildLoginSupportMailto({
  email='',issue='Unable to sign in',error='',origin='',userAgent='',date=new Date()
}={}){
 const safeEmail=String(email||'').trim().slice(0,254);
 const safeIssue=String(issue||'Login assistance').replace(/[\r\n]/g,' ').slice(0,100);
 const safeError=String(error||'').replace(/[\r\n]/g,' ').slice(0,250);
 const safeOrigin=String(origin||'').replace(/[?#].*$/,'').slice(0,240);
 const body=[
   'Hello BPA Solutions Support Team,','',
   'I need help accessing Expense Manager Pro.','',
   'Issue: '+safeIssue,
   'Username / registered email: '+(safeEmail||'Not entered'),
   'Application: Expense Manager Pro',
   'Permanent App ID: bpas-expense-manager-pro',
   'Application version: 2.0',
   'Website: '+(safeOrigin||'Not available'),
   'Reported at (UTC): '+date.toISOString(),
   'Browser: '+String(userAgent||'Not available').slice(0,200),
   ...(safeError?['Error displayed: '+safeError]:[]),
   '',
   'Additional details:',
   '[Please describe what happened and whether a password-reset email arrived.]',
   '',
   'Please assist with restoring access to my account.','',
   'Thank you.'
 ].join('\n');
 const subject='Expense Manager Pro | Login support | '+(safeEmail||'Customer');
 return 'mailto:'+BPA_SUPPORT_EMAIL+'?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(body);
}